// TODO update import after PLAT-3153
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { allowModify } from '../../../permissions';
import { fileEntityName } from '../../entities';
import { applyPermissionsDifferenceToFile } from '../../utils/applyPermissionsDifferenceToFile';
import { calculateFilePermissionsDiff } from '../../utils/calculateFilePermissionsDiff';
import { protectHiddenFileAccess } from '../../utils/protectHiddenFileAccess';
import { updateFilePermissionsBulkActionType } from './types';
export const updateFilePermissions = defineBulkAction({
    type: updateFilePermissionsBulkActionType,
    onAuthBulkAction: (userContext, params) => {
        const storage = userContext.storage(fileEntityName);
        const file = storage.get(params.data.params.fileId);
        protectHiddenFileAccess(file);
        if (!allowModify(userContext.userState, file.data.ownerId, file.data.permissions)) {
            throw new Error('Unauthorized');
        }
        const prevPermissions = file.columns.permissions ? JSON.parse(file.columns.permissions) : {};
        const permissionsDiff = calculateFilePermissionsDiff(prevPermissions, params.data.params.permissions);
        const filter = [
            { column: 'archived', op: '=', value: false },
            { column: 'hidden', op: '=', value: false },
        ];
        return { secureFilter: filter, permissionsDiff };
    },
    onProcessBulkAction: (appContext, { data, updateTotalCount, updateProcessedCount }) => {
        const storage = appContext.storage(fileEntityName);
        let count = 0;
        const totalItems = [];
        let children = storage.list({ filter: [{ op: '=', parentId: data.params.fileId }, ...data.secureParams.secureFilter] }).rows;
        // collect all target folder's children which permissions need to be change
        while (children.length > 0) {
            totalItems.push(...children);
            children = storage.list({
                filter: [{ op: 'in', parentId: children.map((file) => file.id) }, ...data.secureParams.secureFilter],
            }).rows;
        }
        updateTotalCount(totalItems.length + 1);
        storage.post({
            action: 'partial-update',
            data: { permissions: data.params.permissions },
            id: data.params.fileId,
        });
        updateProcessedCount(++count);
        totalItems.forEach((file) => {
            const permissions = file.columns.permissions ? JSON.parse(file.columns.permissions) : {};
            const effectivePermissions = applyPermissionsDifferenceToFile(permissions, data.secureParams.permissionsDiff);
            storage.post({
                action: 'partial-update',
                data: { permissions: effectivePermissions },
                id: file.id,
            });
            updateProcessedCount(++count);
        });
    },
});
